var map = {
	"./proyectos/camaras/1.jpg": 177,
	"./proyectos/camaras/2.jpg": 178,
	"./proyectos/camaras/3.jpg": 179,
	"./proyectos/camaras/4.jpg": 180,
	"./proyectos/camaras/5.jpg": 181,
	"./proyectos/seguridad/1.jpg": 182,
	"./proyectos/seguridad/2.jpg": 183,
	"./proyectos/seguridad/3.jpg": 184,
	"./proyectos/seguridad/4.jpg": 185,
	"./proyectos/seguridad/centromedico.jpg": 186,
	"./proyectos/seguridad/centromedico1.jpg": 187,
	"./proyectos/seguridad/centromedico2.jpg": 188,
	"./proyectos/seguridad/colegio.jpg": 189,
	"./proyectos/seguridad/colegio1.jpg": 190,
	"./proyectos/seguridad/colegio2.jpg": 191,
	"./proyectos/seguridad/colegio3.jpg": 192,
	"./proyectos/seguridad/colegio4.jpg": 193,
	"./proyectos/seguridad/contenedores.jpg": 194,
	"./proyectos/seguridad/contenedores1.jpg": 195,
	"./proyectos/seguridad/contenedores2.jpg": 196,
	"./proyectos/seguridad/contenedores3.jpg": 197,
	"./proyectos/seguridad/contenedores4.jpg": 198,
	"./proyectos/seguridad/contenedores5.jpg": 199,
	"./proyectos/seguridad/contenedores6.jpg": 200,
	"./proyectos/seguridad/contenedores7.jpg": 201,
	"./proyectos/seguridad/segunda.jpg": 202,
	"./proyectos/seguridad/segunda1.jpg": 203,
	"./proyectos/seguridad/segunda2.jpg": 204,
	"./proyectos/seguridad/segunda3.jpg": 205,
	"./proyectos/seguridad/segunda4.jpg": 206,
	"./proyectos/software/callcenter1.png": 207,
	"./proyectos/software/callcenter2.png": 208,
	"./proyectos/software/callcenter3.jpg": 209,
	"./proyectos/software/cc1.png": 210,
	"./proyectos/software/cc2.png": 211,
	"./proyectos/software/cc3.png": 212,
	"./proyectos/software/cc4.png": 213,
	"./proyectos/software/contabilidad.jpg": 214,
	"./proyectos/software/contabilidad1.png": 215,
	"./proyectos/software/contabilidad2.png": 216,
	"./proyectos/software/encuestas.min.png": 217,
	"./proyectos/software/encuestas.png": 218,
	"./proyectos/software/encuestas1.png": 219,
	"./proyectos/software/encuestas2.png": 220,
	"./proyectos/software/encuestas3.png": 221,
	"./proyectos/software/encuestas4.png": 222,
	"./proyectos/software/equipo.jpg": 223,
	"./proyectos/software/expo.min.png": 224,
	"./proyectos/software/expo.png": 225,
	"./proyectos/software/expo1.png": 226,
	"./proyectos/software/expo2.png": 227,
	"./proyectos/software/expo3.png": 228,
	"./proyectos/software/expo4.png": 229,
	"./proyectos/software/facturacion.jpg": 230,
	"./proyectos/software/facturacion1.png": 231,
	"./proyectos/software/facturacion2.png": 232,
	"./proyectos/software/facturacion3.png": 233,
	"./proyectos/software/impo.min.png": 234,
	"./proyectos/software/impo.png": 235,
	"./proyectos/software/impo.resize.png": 236,
	"./proyectos/software/impo1.png": 237,
	"./proyectos/software/impo2.png": 238,
	"./proyectos/software/impo3.png": 239,
	"./proyectos/software/impo4.png": 240,
	"./proyectos/software/macanpro.jpg": 241,
	"./proyectos/software/meet.min.png": 242,
	"./proyectos/software/meet.png": 243,
	"./proyectos/software/meet1.png": 244,
	"./proyectos/software/meet2.png": 245,
	"./proyectos/software/meet3.png": 246,
	"./proyectos/software/sgd.png": 247,
	"./proyectos/software/shopping.min.png": 248,
	"./proyectos/software/shopping.png": 249,
	"./proyectos/software/telefonia.jpg": 250,
	"./proyectos/software/tracking.jpg": 251,
	"./proyectos/software/tracking.png": 252,
	"./proyectos/software/tracking_1.png": 253,
	"./proyectos/software/tracking_2.png": 254,
	"./proyectos/software/tracking_3.png": 255
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/proyectos.*$
// module id = 15
// module chunks = 0